import { render, staticRenderFns } from "./company-tag-edit.vue?vue&type=template&id=1b2896f9&scoped=true&"
import script from "./company-tag-edit.vue?vue&type=script&lang=js&"
export * from "./company-tag-edit.vue?vue&type=script&lang=js&"
import style0 from "./company-tag-edit.vue?vue&type=style&index=0&id=1b2896f9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2896f9",
  null
  
)

export default component.exports